import { mantutencao_parametros_comprovante_de_reserva } from "./mantutencao-parametros-comprovante-de-reserva";
import { vagas_por_tipo_de_deficiencia } from "./vagas-por-tipo-de-deficiencia";
import { manutencao_de_parametro_do_ano_de_matricula } from "./manutencao-de-parametro-do-ano-de-matricula";
import { manutencao_de_parametro_grupo_de_atendimento } from "./manutencao-de-parametro-grupo-de-atendimento";

const parametros_de_atendimento = [
  mantutencao_parametros_comprovante_de_reserva,
  vagas_por_tipo_de_deficiencia,
  manutencao_de_parametro_do_ano_de_matricula,
  manutencao_de_parametro_grupo_de_atendimento,
];

export { parametros_de_atendimento };
